var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4459_22966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99996 5.33341L3.99996 4.00008M3.99996 2.66675H4.00329M7.33329 4.00008C7.33329 5.84103 5.84091 7.33341 3.99996 7.33341C2.15901 7.33341 0.666626 5.84103 0.666626 4.00008C0.666626 2.15913 2.15901 0.666748 3.99996 0.666748C5.84091 0.666748 7.33329 2.15913 7.33329 4.00008Z",
    stroke: "#7C868B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4459_22966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleWhite);
export default __webpack_public_path__ + "static/media/info-circle-white.ff537fb3c9e1f5518951eac4d4cfd5eb.svg";
export { ForwardRef as ReactComponent };